import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    address2,
    caseAccounting,
    district2,
    fromMonth,
    organizationName,
    province2,
    taxId2,
    toMonth,
    checkbox1,
    moneyRefund,
    ownerBankName,
    accountNumber,
    bankName,
    receiverName,
    receiverNameId,
    date,
    place,
    inventory,
    typeRefund,
    certificate,
    timeSign,
    signer,
    fullName,
    fullName2,
    identity,
  },
} = checkout;

const initialValues = {
  [fullName2.name]: "",
  [identity.name]: "",
  [typeRefund.name]: "",
  [moneyRefund.name]: "",
  [ownerBankName.name]: "",
  [bankName.name]: "",
  [accountNumber.name]: "",
  [receiverName.name]: "",
  [receiverNameId.name]: "",
  [date.name]: "",
  [place.name]: "",
  [inventory.name]: "",
  [address2.name]: "",
  [caseAccounting.name]: "",
  [checkbox1.name]: false,
  [district2.name]: "",
  [fromMonth.name]: "",
  [organizationName.name]: "",
  [province2.name]: "",
  [taxId2.name]: "",
  [toMonth.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [district.name]: "",
  [province.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [address.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
